import React from "react";
import PropTypes from "prop-types";
import { cropNumber } from "../../../../../../../common/helpers/helpers";
import { rankScoresExplanations } from "../../rankScoresExplanations";

const CustomScoreCell = ({
  values,
  title,
  name,
  testId,
  displayExplanation,
}) => {
  if (Array.isArray(values) && values?.length > 0) {
    return (
      <>
        <div
          data-testid={`${testId}-title`}
          className="varsome-horiz-list-label varsome-dbnsfp-label"
        >
          {title}
        </div>
        <div className="varsome-horiz-list-value">
          <span data-testid={testId} style={{ color: "#818a91" }}>
            {values.map((x) => cropNumber(x)).join(", ")}
            {displayExplanation ? (
              <span data-testid={`${testId}-explanation`}>
                {rankScoresExplanations(name)}
              </span>
            ) : null}
          </span>
        </div>
      </>
    );
  }
  return null;
};

CustomScoreCell.propTypes = {
  title: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.number),
  displayExplanation: PropTypes.bool,
  name: PropTypes.string,
  testId: PropTypes.string,
};

CustomScoreCell.defaultProps = {
  title: "",
  values: [],
  displayExplanation: false,
  name: "",
  testId: "",
};

export default CustomScoreCell;
